
export default {
  model: {
    prop: 'checked'
  },

  props: {
    label: { type: String, default: null },
    checked: { type: Boolean, default: false }
  }
}
